import {createSlice} from '@reduxjs/toolkit'

export const salesTargetInitialState = {
  formData: {
    activeDisplay: true,
  },
  displayContent: {
    en: {
      newDisplayTitle: '',
      parentCategory: '',
      childCategory: '',
      exerpt: '',
      terms: '',
    },
  },
  displayContentMedia: {
    title: '',
    imageId: '',
    imageUri: '',
    imageBase64: '',
    optIn: false,
  },
  selectedCategory: [],
  excludedProducts: [],
  includedProducts: [],
}

const salesTargetSlice = createSlice({
  name: 'salesTarget',
  initialState: salesTargetInitialState,
  reducers: {
    setSalesTargetDisplayContent: (state, action) => {
      return {
        ...state,
        displayContent: action.payload,
      }
    },
    resetSalesTarget: () => salesTargetInitialState,
    setSalesTargetDisplayContentMedia: (state, action) => {
      return {
        ...state,
        displayContentMedia: action.payload,
      }
    },
    resetSalesTargetDisplayContentMedia: state => {
      return {
        ...state,
        displayContentMedia: {
          title: '',
          imageId: '',
          imageUri: '',
          imageBase64: '',
        },
      }
    },
    setSalesTargetFormData: (state, action) => {
      return {
        ...state,
        formData: action.payload,
      }
    },
    setSalesTargetSelectedCategory: (state, action) => {
      return {
        ...state,
        selectedCategory: action.payload,
      }
    },
    // Add a product to the excluded list
    // First removes it from included list if present, then adds to excluded list if not already there
    addExcludedProduct: (state, action) => {
      const productId = action.payload
      state.includedProducts = state.includedProducts.filter(id => id !== productId)
      if (!state.excludedProducts.includes(productId)) {
        state.excludedProducts.push(productId)
      }
    },
    
    // Remove a product from the excluded list
    // Simply filters out the specified product ID from the excluded products array
    removeExcludedProduct: (state, action) => {
      state.excludedProducts = state.excludedProducts.filter(id => id !== action.payload)
    },
    
    // Add a product to the included list
    // First removes it from excluded list if present, then adds to included list if not already there
    addIncludedProduct: (state, action) => {
      const productId = action.payload
      state.excludedProducts = state.excludedProducts.filter(id => id !== productId)
      if (!state.includedProducts.includes(productId)) {
        state.includedProducts.push(productId)
      }
    },
    
    // Remove a product from the included list
    // Simply filters out the specified product ID from the included products array
    removeIncludedProduct: (state, action) => {
      state.includedProducts = state.includedProducts.filter(id => id !== action.payload)
    },
  },
})

export const {
  setSalesTargetDisplayContent,
  setSalesTargetDisplayContentMedia,
  resetSalesTargetDisplayContentMedia,
  resetSalesTarget,
  setSalesTargetFormData,
  setSalesTargetSelectedCategory,
  addExcludedProduct,
  removeExcludedProduct,
  addIncludedProduct,
  removeIncludedProduct,
} = salesTargetSlice.actions

export const salesTargetSliceReducer = salesTargetSlice.reducer
